import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import StandingsSelect from "../headtohead/StandingsSelect";

//HOOKS
import usePlayerProfiles from "../../hooks/usePlayerProfiles";

const SERVER_URL = window.location.protocol + "//" + window.location.host;

function getBool(val) {
   if (val) {
      return !!JSON.parse(String(val).toLowerCase());
   }
}

export default function PlayerProfileGrid({
   loadDownloader,
   clearDownloader
}) {

   const [
      notification,
      allPlayerProfiles,
      playerProfile,
      show,
      runTimestamp,
      { getAllPlayerProfiles },
   ] = usePlayerProfiles();

   const [standingsId, setStandingsId] = useState(0);
   const [standingsRound, setStandingsRound] = useState("MostRecent");

   useEffect(() => {
      getAllPlayerProfiles();
   }, []);

   const refreshGrid = () => {
      getAllPlayerProfiles();
      clearDownloader();
   };

   let columns;
   let initialState;

   // console.log(allPlayerProfiles);
   columns = [
      {
         field: "id",
         headerName: "Player Profile Id",
         editable: false,
         width: 100,
         filterable: false,
      },
      {
         field: "Player",
         headerName: "Player",
         editable: false,
         width: 200,
         filterable: false,
         valueGetter: (params) => params.row.Player && params.row.Player.PlayerName ? params.row.Player.PlayerName : "-NONE-",
      },
      {
         field: "StandingsId",
         headerName: "Round Standings",
         editable: false,
         width: 300,
         filterable: false,
         renderCell: (params) => (
            <StandingsSelect
               disabled={true}
               selected={params.row.StandingsId}
               callback={console.log}
            />
         )
      },
      {
         field: "PreviewPlayerProfile",
         headerName: "",
         editable: false,
         width: 300,
         filterable: false,
         sortable: false,
         renderCell: (params) => (
            <>
               <Button
                  size='small'
                  onClick={() => {
                     const roundId = standingsId === 0 || standingsId === '0' ? 0 : (standingsId === 9999999 || standingsId === '9999999' ? 9999999 : Number(standingsId));
                     loadDownloader("playerprofile", params.row.id, roundId, "PlayerProfile_" + (params.row.Player && params.row.Player.PlayerName ? params.row.Player.PlayerName.replace(/[^a-zA-Z]/g, "") : "none") + "_" + standingsRound);
                  }}
                  sx={{ mr: 1 }}
               >
                  LOAD PLAYER PROFILE
               </Button>
            </>
         ),
      }
   ];

   initialState = {
      sorting: {
         // sortModel: [{ field: "LastName", sort: "asc" }],
      },
      columns: {
         columnVisibilityModel: {
            id: false
         },
      },
   };

   return (
      <>
         <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
            <Typography variant="h3" component="div" sx={{ textTransform: "uppercase" }}>Player Profile</Typography>
            <Button onClick={refreshGrid} color="error" variant="outlined">Refresh Data</Button>
         </Stack>
         
         <Box sx={{ py: 2, px: 4, backgroundColor: "#fff", mb: 2 }}>
            <StandingsSelect
               backgroundColor={null}
               selected={standingsId}
               callback={(data) => {
                  if (data && data.id !== null && data.id !== undefined) {
                     const roundId = data.id === '0' ? 0 : (data.id === '9999999' ? 9999999 : Number(data.id));
                     setStandingsId(roundId);
                     setStandingsRound(data.value || "MostRecent");
                     clearDownloader();
                  }
               }}
            />
         </Box>
         
         <Box height={400} width="100%">
            {allPlayerProfiles && (
               <DataGrid
                  initialState={initialState}
                  sx={{ backgroundColor: "#efefef" }}
                  rows={allPlayerProfiles}
                  rowHeight={40}
                  columns={columns}
                  rowsPerPageOptions={[100, 200, 300, 1000, 5000]}
                  components={{ Toolbar: GridToolbar }}
                  componentsProps={{
                     toolbar: {
                        printOptions: {
                           disableToolbarButton: true,
                        },
                     },
                  }}
                  disableColumnSelector
                  disableDensitySelector
                  disableSelectionOnClick
               />
            )}
         </Box>
      </>
   );
}
